/*
 * CAPTURE-OWNED MODULE
 * Template Studio main page for capture-ui
 * This replaces the Template Studio functionality from root /src
 */

import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import TemplateListPage from './TemplateListPage';
import TemplateEditorPage from './TemplateEditorPage';
import './TemplateStudio.css';

const TemplateStudio = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [currentView, setCurrentView] = useState('list'); // 'list' | 'editor'
  const [selectedTemplateId, setSelectedTemplateId] = useState(null);

  // Auto-open template from URL param (e.g. /template-studio?openTemplate=abc-123)
  useEffect(() => {
    const openId = searchParams.get('openTemplate');
    if (openId && openId !== selectedTemplateId) {
      console.log('[TemplateStudio] Auto-opening template from URL:', openId);
      setSelectedTemplateId(openId);
      setCurrentView('editor');
      // Clear the param so refresh doesn't re-trigger
      setSearchParams({}, { replace: true });
    }
  }, [searchParams, selectedTemplateId, setSearchParams]);

  const handleOpenTemplate = (templateId) => {
    setSelectedTemplateId(templateId);
    setCurrentView('editor');
  };

  const handleBackToList = () => {
    setCurrentView('list');
    setSelectedTemplateId(null);
  };

  return (
    <div className="template-studio">
      {currentView === 'list' && (
        <TemplateListPage onOpenTemplate={handleOpenTemplate} />
      )}
      
      {currentView === 'editor' && (
        <TemplateEditorPage 
          templateId={selectedTemplateId}
          onBack={handleBackToList}
        />
      )}
    </div>
  );
};

export default TemplateStudio;
